const setFinanceFormSsnFieldLogging = (form) => {
	// This will automatically set a custom attribute when a finance form is submitted
	const ssnField = form?.querySelector('[name="applicant.ssn"]');

	const hasShortSsnField = ssnField?.pattern === '(^$)|(^\\d{4}$)';

	if (hasShortSsnField) {
		window?.newrelic?.setCustomAttribute(
			'hasShortSsnField',
			hasShortSsnField
		);
	}
};

export default setFinanceFormSsnFieldLogging;
